import React from 'react';
import { useSiteSettings } from '../../hooks/useSiteSettings';

const PromptsTab = ({
  testMessage, setTestMessage, testResult,
  testPromptHandler, saveSettings,
  operationMode, setOperationMode,
  demoWhatsappNumber, setDemoWhatsappNumber,
  demoInstagramId, setDemoInstagramId,
  saveOperationMode,
  companyPrompt, setCompanyPrompt, saveCompanyPrompt,
  promptMode, systemPrompt, onMigrateToLayered, onRevertToLegacy,
  industryStandardPrompt, industryStandardVersion, industryStandardAvailable,
  composedPrompt, composedLength, unresolvedTokens, missingStandard,
  loading, onOpenHistory,
  onboardingLink, copyOnboardingLink, onboardingSubmissions, onReviewSubmission
}) => {
  const brand = useSiteSettings();
  const isDemo = operationMode === 'demo';
  const isLegacy = promptMode !== 'layered';
  return (
    <div className="pt-tab">
      {/* Header */}
      <div className="pt-actions-card">
        <div className="pt-actions-left">
          <h2>✨ Prompt Yönetimi</h2>
          <p>AI asistanınızın davranışını şekillendirin</p>
        </div>
      </div>

      {/* Online / Demo Modu */}
      <div className="pt-card">
        <div className="pt-card-header">
          <div>
            <h3>{isDemo ? '🧪 Demo Modu' : '🟢 Online Modu'}</h3>
            <p className="pt-card-sub">
              {isDemo
                ? 'AI sadece aşağıya yazdığınız WhatsApp numarasına ve Instagram ID\'ye cevap veriyor — diğer müşteriler etkilenmiyor'
                : 'AI tüm müşterilere normal şekilde cevap veriyor'}
            </p>
          </div>
          <label className="pt-switch">
            <input type="checkbox" checked={isDemo} onChange={e => setOperationMode(e.target.checked ? 'demo' : 'online')} />
            <span className="pt-switch-slider" />
          </label>
        </div>

        {isDemo && (
          <>
            <div className="pt-warn-info" style={{ marginBottom: 16 }}>
              ⚠️ Demo modda, buraya yazmadığınız hiçbir müşteriye AI cevap vermez. Canlıya almadan önce mutlaka <strong>Online</strong>'a geri alın.
            </div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 8 }}>
              <div style={{ flex: '1 1 260px' }}>
                <label className="form-label" style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 4, display: 'block' }}>Test WhatsApp Numarası</label>
                <input
                  className="input"
                  placeholder="Örn: 05xx xxx xx xx"
                  value={demoWhatsappNumber}
                  onChange={e => setDemoWhatsappNumber(e.target.value)}
                />
              </div>
              <div style={{ flex: '1 1 260px' }}>
                <label className="form-label" style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 4, display: 'block' }}>Test Instagram ID</label>
                <input
                  className="input"
                  placeholder="Sayısal Instagram ID (kullanıcı adı değil)"
                  value={demoInstagramId}
                  onChange={e => setDemoInstagramId(e.target.value)}
                />
              </div>
            </div>
            <p className="pt-card-sub" style={{ marginBottom: 16 }}>
              Instagram ID'nizi bulmak için: kişisel hesabınızdan işletme Instagram hesabınıza bir DM atın, sonra Mesajlar sayfasında o sohbeti açıp orada görünen numarayı buraya yapıştırın.
            </p>
          </>
        )}

        <button className="pt-btn-save" onClick={saveOperationMode} disabled={loading}>
          {loading ? '...' : '💾 Kaydet'}
        </button>
      </div>

      {/* Musteri bilgi formu linki */}
      <div className="pt-card">
        <div className="pt-card-header">
          <div>
            <h3>🔗 Müşteriye Bilgi Formu Gönder</h3>
            <p className="pt-card-sub">İşletme sahibi kendi bilgilerini doldursun, prompt taslağı otomatik hazırlansın</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <input className="input" readOnly value={onboardingLink} onFocus={e => e.target.select()} style={{ flex: 1 }} />
          <button className="pt-btn-manual" onClick={copyOnboardingLink} disabled={!onboardingLink}>📋 Kopyala</button>
        </div>
      </div>

      {/* Form Yanıtları */}
      <div className="pt-card">
        <div className="pt-card-header">
          <h3>📋 Form Yanıtları</h3>
          {onboardingSubmissions.length > 0 && (
            <span className="pt-count">{onboardingSubmissions.filter(s => s.status === 'pending').length} bekliyor</span>
          )}
        </div>
        {onboardingSubmissions.length === 0 ? (
          <p className="pt-card-sub">Henüz form yanıtı yok.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {onboardingSubmissions.map(s => (
              <div key={s.id} className="pt-custom-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div className="pt-custom-name">{s.business_name}</div>
                  <div className="pt-custom-desc">{new Date(s.created_at).toLocaleString('tr-TR')} · {s.status === 'pending' ? '⏳ Bekliyor' : '✅ İşlendi'}</div>
                </div>
                <button className="pt-action-btn use" onClick={() => onReviewSubmission(s)}>İncele</button>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Prompt Sistemi (eski tek-parça vs yeni katmanlı mod) */}
      <div className={`pt-card ${isLegacy ? 'pt-mode-legacy' : ''}`}>
        <div className="pt-card-header">
          <div>
            <h3>{isLegacy ? '🗄️ Eski Sistem (Tek Parça Prompt)' : '✅ Yeni Sistem (Katmanlı Mod)'}</h3>
            <p className="pt-card-sub">
              {isLegacy
                ? 'Bu işletme henüz sektör standardını kullanmıyor. Aşağıdaki "Sektör Standardı" ve "İşletmenize Özel Eklemeleri" bölümleri bu işletmede AKTİF DEĞİL — canlıda hâlâ eski (tek parça) prompt kullanılıyor.'
                : 'Bu işletme sektör standardı + işletmeye özel ekleri birleştiren yeni sistemi kullanıyor.'}
            </p>
          </div>
        </div>

        {isLegacy ? (
          <>
            {!industryStandardAvailable && (
              <div className="pt-warn-info">
                ⚠️ Bu sektör için henüz bir standart tanımlanmadı — tanımlanana kadar yeni sisteme geçilemez.
              </div>
            )}
            <button
              className="pt-btn-save"
              onClick={onMigrateToLayered}
              disabled={loading || !industryStandardAvailable}
            >
              {loading ? '...' : '🆕 Yeni Sisteme Geç'}
            </button>
          </>
        ) : (
          <button className="pt-btn-history" onClick={onRevertToLegacy} disabled={loading}>
            {loading ? '...' : '↩️ Eski Moda Dön'}
          </button>
        )}
      </div>

      {/* Sektör Standardı + İşletmeye Özel Ekler + Birleşik Sonuç */}
      <div className="pt-card">
        <div className="pt-card-header">
          <div>
            <h3>🔒 Sektör Standardı</h3>
            <p className="pt-card-sub">{brand.site_name || 'Platform'} tarafından yönetilir, sektörünüzdeki tüm işletmeler için ortaktır</p>
          </div>
          <span className="pt-version-badge">🔒 {brand.site_name || 'Platform'} yönetiyor · v{industryStandardVersion || 0}</span>
        </div>
        {missingStandard && (
          <div className="pt-warn-info">
            ⚠️ Sektörünüz için henüz bir standart tanımlanmadı — geçici olarak eski promptunuz kullanılıyor.
          </div>
        )}
        <textarea className="pt-editor pt-editor-readonly" value={industryStandardPrompt || ''} readOnly rows={8} />
      </div>

      <div className="pt-card">
        <div className="pt-card-header">
          <div>
            <h3>✏️ İşletmenize Özel Eklemeler</h3>
            <p className="pt-card-sub">Sektör standardının üzerine eklenir; çelişki olursa bu bölüm önceliklidir</p>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button className="pt-btn-history" onClick={() => onOpenHistory()}>🕐 Geçmiş</button>
            <button className="pt-btn-save" onClick={saveCompanyPrompt} disabled={loading}>
              {loading ? '...' : '💾 Kaydet'}
            </button>
          </div>
        </div>
        <textarea
          className="pt-editor"
          value={companyPrompt}
          onChange={e => setCompanyPrompt(e.target.value)}
          placeholder="Örn: Salonumuz Pazar günleri kapalıdır. Kapıda ücretsiz otoparkımız var. Randevusuz müşteri kabul etmiyoruz..."
          rows={8}
        />
        <div className="pt-editor-stats">
          <span>{companyPrompt?.length || 0} karakter</span>
        </div>
      </div>

      <div className="pt-card">
        <div className="pt-card-header">
          <div>
            <h3>👁️ Birleşik Sonuç</h3>
            <p className="pt-card-sub">AI'a gerçekte giden metin budur (salt okunur önizleme)</p>
          </div>
        </div>
        {unresolvedTokens?.length > 0 && (
          <div className="pt-warn-info pt-warn-danger">
            ⚠️ Çözülmemiş jeton(lar): {unresolvedTokens.join(', ')} — bu şekilde müşteriye gidebilir, {brand.site_name || 'destek ekibi'} ile iletişime geçin.
          </div>
        )}
        <textarea className="pt-editor pt-editor-readonly" value={composedPrompt || ''} readOnly rows={10} />
        <div className="pt-editor-stats">
          <span>{composedLength || 0} karakter</span>
          <span>~{Math.ceil((composedLength || 0) / 4)} token</span>
        </div>
      </div>

      {/* Live Test */}
      <div className="pt-card">
        <div className="pt-card-header">
          <h3>🧪 Canlı Test</h3>
        </div>
        <p className="pt-card-sub" style={{ marginBottom: 12 }}>Bu test, mevcut birleşik promptunuzla (Sektör Standardı + İşletmenize Özel Eklemeleriniz) çalışır.</p>
        <div className="pt-test-area">
          <textarea
            className="pt-test-input"
            rows={3}
            placeholder="Müşteri mesajını test edin... Örn: Saç boyama fiyatı nedir?"
            value={testMessage}
            onChange={e => setTestMessage(e.target.value)}
          />
          <button className="pt-test-btn" onClick={testPromptHandler} disabled={loading || !testMessage.trim() || !composedPrompt?.trim()}>
            {loading ? '⏳ Test Ediliyor...' : '🚀 Test Et'}
          </button>
        </div>

        {testResult && (
          <div className="pt-result">
            <div className="pt-result-header">
              <span>🤖 AI Yanıtı</span>
              <span className="pt-result-meta">{testResult.provider?.toUpperCase()} · {testResult.model}</span>
            </div>
            <pre className="pt-result-body">{testResult.response || testResult.error}</pre>
          </div>
        )}
      </div>

      <style>{`
        .pt-tab { display:flex; flex-direction:column; gap:20px; }

        .pt-actions-card { background:linear-gradient(135deg,rgba(var(--tertiary-rgb),0.12),rgba(167,139,250,0.06)); border:1px solid rgba(167,139,250,0.2); border-radius:18px; padding:24px; display:flex; justify-content:space-between; align-items:center; }
        .pt-actions-left h2 { margin:0 0 4px; font-size:22px; font-weight:700; color:#F9FAFB; }
        .pt-actions-left p { margin:0; font-size:13px; color:#6B7280; }
        .pt-btn-manual { padding:11px 22px; background:rgba(255,255,255,0.07); border:1px solid rgba(255,255,255,0.12); border-radius:12px; color:#E5E7EB; font-size:14px; font-weight:600; cursor:pointer; transition:all 0.2s; }
        .pt-btn-manual:hover { background:rgba(255,255,255,0.12); }

        .pt-card { background:rgba(17,17,24,0.7); border:1px solid rgba(255,255,255,0.07); border-radius:18px; padding:24px; backdrop-filter:blur(16px); }
        .pt-mode-legacy { border-color:rgba(251,191,36,0.3); background:rgba(251,191,36,0.04); }
        .pt-card-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; }
        .pt-card-header h3 { margin:0 0 2px; font-size:17px; font-weight:700; color:#F9FAFB; }
        .pt-card-sub { margin:0; font-size:12px; color:#6B7280; }
        .pt-count { background:rgba(167,139,250,0.12); color:#a78bfa; border:1px solid rgba(167,139,250,0.2); padding:3px 10px; border-radius:20px; font-size:12px; font-weight:700; }

        .pt-switch { position:relative; display:inline-block; width:52px; height:28px; flex-shrink:0; }
        .pt-switch input { opacity:0; width:0; height:0; }
        .pt-switch-slider { position:absolute; cursor:pointer; inset:0; background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.1); border-radius:28px; transition:0.35s; }
        .pt-switch-slider:before { position:absolute; content:""; height:20px; width:20px; left:3px; bottom:3px; background:#fff; border-radius:50%; transition:0.35s; box-shadow:0 2px 6px rgba(0,0,0,0.3); }
        .pt-switch input:checked + .pt-switch-slider { background:rgba(251,191,36,0.25); border-color:rgba(251,191,36,0.5); }
        .pt-switch input:checked + .pt-switch-slider:before { transform:translateX(24px); background:#FBBF24; }

        .pt-custom-card { background:rgba(255,255,255,0.03); border:1px solid rgba(255,255,255,0.07); border-radius:14px; padding:16px; }
        .pt-custom-name { font-size:14px; font-weight:700; color:#E5E7EB; margin-bottom:3px; display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
        .pt-custom-desc { font-size:12px; color:#6B7280; }
        .pt-action-btn { padding:5px 10px; border:none; border-radius:7px; font-size:12px; font-weight:600; cursor:pointer; transition:all 0.15s; }
        .pt-action-btn.use { background:rgba(96,165,250,0.12); color:#60A5FA; }
        .pt-action-btn:hover { opacity:0.8; }

        .pt-version-badge { background:rgba(167,139,250,0.12); color:#a78bfa; border:1px solid rgba(167,139,250,0.25); padding:5px 12px; border-radius:20px; font-size:12px; font-weight:700; white-space:nowrap; }
        .pt-warn-info { background:rgba(251,191,36,0.08); border:1px solid rgba(251,191,36,0.25); color:#FBBF24; border-radius:10px; padding:10px 14px; font-size:13px; margin-bottom:14px; }
        .pt-warn-danger { background:rgba(248,113,113,0.08); border-color:rgba(248,113,113,0.25); color:#F87171; }
        .pt-editor-readonly { opacity:0.75; cursor:not-allowed; }

        .pt-editor { width:100%; padding:16px; background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.08); border-radius:12px; color:#E5E7EB; font-size:13px; font-family:'Monaco','Menlo','Ubuntu Mono',monospace; line-height:1.7; resize:vertical; outline:none; transition:border-color 0.2s; box-sizing:border-box; }
        .pt-editor:focus { border-color:rgba(167,139,250,0.4); background:rgba(255,255,255,0.05); }
        .pt-editor-stats { display:flex; gap:16px; margin-top:8px; font-size:11px; color:#4B5563; justify-content:flex-end; }

        .pt-btn-history { padding:9px 16px; background:rgba(251,191,36,0.1); border:1px solid rgba(251,191,36,0.2); border-radius:10px; color:#FBBF24; font-size:13px; font-weight:600; cursor:pointer; transition:all 0.2s; }
        .pt-btn-history:hover { background:rgba(251,191,36,0.18); }
        .pt-btn-save { padding:9px 18px; background:linear-gradient(135deg,#7c3aed,#a78bfa); border:none; border-radius:10px; color:#fff; font-size:13px; font-weight:700; cursor:pointer; }
        .pt-btn-save:disabled { opacity:0.6; cursor:not-allowed; }

        .pt-test-area { display:flex; flex-direction:column; gap:12px; }
        .pt-test-input { width:100%; padding:14px; background:rgba(255,255,255,0.04); border:1px solid rgba(255,255,255,0.08); border-radius:12px; color:#E5E7EB; font-size:14px; resize:vertical; outline:none; font-family:inherit; box-sizing:border-box; }
        .pt-test-input:focus { border-color:rgba(52,211,153,0.4); }
        .pt-test-btn { align-self:flex-start; padding:10px 24px; background:linear-gradient(135deg,#059669,#34D399); border:none; border-radius:10px; color:#fff; font-size:14px; font-weight:700; cursor:pointer; transition:all 0.2s; }
        .pt-test-btn:disabled { opacity:0.5; cursor:not-allowed; }
        .pt-test-btn:not(:disabled):hover { transform:translateY(-1px); box-shadow:0 6px 20px rgba(52,211,153,0.3); }

        .pt-result { margin-top:20px; background:rgba(96,165,250,0.06); border:1px solid rgba(96,165,250,0.2); border-radius:14px; overflow:hidden; }
        .pt-result-header { display:flex; justify-content:space-between; align-items:center; padding:12px 16px; border-bottom:1px solid rgba(96,165,250,0.15); font-size:13px; font-weight:700; color:#60A5FA; }
        .pt-result-meta { font-size:11px; color:#6B7280; font-weight:400; font-family:monospace; }
        .pt-result-body { margin:0; padding:16px; white-space:pre-wrap; font-size:14px; color:#D1D5DB; line-height:1.7; font-family:inherit; }
      `}</style>
    </div>
  );
};

export default PromptsTab;
